<su-headline h="h1" skin="primary">{{ 'menu.tenant_invoices.component.invoices' | translate }} - {{ tenantName }} - {{ contractName }}</su-headline>

<div class="row-chips">
  <su-chip [items]="chips" (onRemove)="handleOnRemoveChip($event)"></su-chip>
</div>

<ng-template #toolbarTpl>
  <su-slot-controls
    [mainTLabel]="'crud.filter' | translate"
    [buttons]="controlButtons"
    [chips]="chips"
    [menuItems]="menuItems"
    [dialogData]="dialogData"
    (onCloseDialog)="onCloseDialog($event)"
    [modal]="modalComponent">
  </su-slot-controls>
</ng-template>

<mtx-grid
  [columnResizable]="true"
  [columns]="columns"
  [data]="data.items"
  [length]="data.totalCount"
  [pageOnFront]="false"
  [sortOnFront]="false"
  [sortActive]="'invoiceDate'"
  [sortDirection]="'desc'"
  [loading]="isLoading"
  [rowStriped]="true"
  [noResultText]="noResultText"
  [pageSizeOptions]="[5, 10, 25, 50, 100]"
  [pageSize]="config.grid.paging.pageSize"
  [pageIndex]="config.grid.paging.pageIndex"
  [showPaginator]="config.grid.paging.showPaginator"
  [columnMenuButtonText]="'grid.columns_shown' | translate"
  [showSidebar]="true"
  [showToolbar]="true"
  [columnSortable]="true"
  [showColumnMenuButton]="true"
  [columnHideable]="true"
  [columnHideableChecked]="'show' | translate"
  columnMenuButtonClass="col-button"
  columnMenuButtonType="flat"
  [columnPinnable]="false"
  [toolbarTemplate]="toolbarTpl"
  (sortChange)="sortChange($event)"
  (columnChange)="columnsChanged($event)"
  (page)="getNextPage($event)">
</mtx-grid>

<app-spinner-overlay [show]="loading" label=""></app-spinner-overlay>

<ng-template #downloadInvoiceTemplate let-row let-index="index" let-col="colDef">
  <su-button
    [skin]="'primary'"
    icon="paperclip"
    (onClick)="downloadInvoice($event, row)"
    [ariaLabel]="'documents.title' | translate">
  </su-button>
</ng-template>

<ng-template #newInvoiceTemplate let-row>
  <div class="icon-container">
    <mat-icon class="mr-8">
      {{ row.readAt == null ? 'error_outline_outlined' : '' }}
    </mat-icon>
  </div>
</ng-template>
